import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import Preferential from '../../entities/booking/preferential';
import Util from '../../../lib/util';

interface PreferentialState extends ListState<Preferential>{
    editPreferential:Preferential
}
class PreferentialMutations extends ListMutations<Preferential>{

}
class PreferentialModule extends ListModule<PreferentialState,any,Preferential>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Preferential>(),
        loading:false,
        editPreferential:new Preferential()
    }
    actions={
        async getAll(context:ActionContext<PreferentialState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Preferential/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Preferential>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<PreferentialState,any>,payload:any){
            await Ajax.post('/api/services/app/Preferential/Create',payload.data);
        },
        async update(context:ActionContext<PreferentialState,any>,payload:any){
            await Ajax.put('/api/services/app/Preferential/Update',payload.data);
        },
        async delete(context:ActionContext<PreferentialState,any>,payload:any){
            await Ajax.delete('/api/services/app/Preferential/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<PreferentialState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Preferential/Get?Id='+payload.id);
            return reponse.data.result as Preferential;
        }
    };
    mutations={
        setCurrentPage(state:PreferentialState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:PreferentialState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:PreferentialState,preferential:Preferential){
            state.editPreferential=preferential;
        }
    }
}
const preferentialModule=new PreferentialModule();
export default preferentialModule;